import { render, staticRenderFns } from "./campaignAutomationStats.vue?vue&type=template&id=870f9dda&scoped=true"
import script from "./campaignAutomationStats.vue?vue&type=script&lang=js"
export * from "./campaignAutomationStats.vue?vue&type=script&lang=js"
import style0 from "./campaignAutomationStats.vue?vue&type=style&index=0&id=870f9dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f9dda",
  null
  
)

export default component.exports